// extracted by mini-css-extract-plugin
module.exports = {"colFlex":"risk-profile_colFlex__piCE4","riskContainer":"risk-profile_riskContainer__2iHfL","sidebar":"risk-profile_sidebar__1ZhVA","flexBox":"risk-profile_flexBox__2Yb0i"};